import React, { useContext, useState } from "react";
import ChangePasswordView from "../../views/account/ChangePasswordView";
import { Request } from "../../api/auth/Password.api";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { Box } from "@material-ui/core";
import { AuthContext } from "../../context/auth/AuthContext";
import { useTranslation } from "react-i18next";

const initialValues = {
  password: "",
  new_password: "",
  confirm_password: "",
};

const PasswordContainer = () => {
  const { t } = useTranslation();

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token } = useContext(AuthContext);

  const onSubmit = (values, actions) => {
    setError(null);
    setLoading(true);
    Request.changePassword(token, values)
      .then((data) => onSuccess(data, actions))
      .catch((error) => onFailure(error, actions));
  };

  const onSuccess = ({ data }, actions) => {
    actions.setSubmitting(false);
    setLoading(false);
  };

  const onFailure = (error, actions) => {
    if (error.message === "password_mismatch") {
      setError({
        message: t("profile.change_password.errors.password_mismatch"),
      });
    } else if (error.message === "wrong_password") {
      setError({ message: t("profile.change_password.errors.wrong_password") });
    } else {
      setError(error);
    }
    setLoading(false);
    actions.setSubmitting(false);
  };

  return (
    <Box p={2}>
      {error ? <Error message={error} onClose={() => setError(null)} /> : null}
      {loading ? <Loading /> : null}
      <ChangePasswordView onSubmit={onSubmit} initialValues={initialValues} />
    </Box>
  );
};

export default PasswordContainer;
